import { Link } from 'react-router';
import { LegalPageShell, LegalSection } from '../components/LegalPageShell';
import { PANEL_URL } from '../lib/api';

export default function AccountDeletionPage() {
  const updated = new Date().toLocaleDateString('pl-PL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <LegalPageShell
      title="Usunięcie konta i danych"
      subtitle={`Jak trwale usunąć konto Turnivo oraz powiązane dane osobowe. Ostatnia aktualizacja: ${updated}`}
    >
      <LegalSection title="1. Cel tej strony">
        <p>
          Ta strona spełnia wymagania sklepów Google Play i Apple App Store dotyczące udostępnienia
          publicznego adresu URL z informacją, jak użytkownik może poprosić o usunięcie konta i
          powiązanych danych. W Turnivo usunięcie konta wykonujesz samodzielnie — bez wysyłania
          wniosku e-mailem.
        </p>
      </LegalSection>

      <LegalSection title="2. Jak usunąć konto (zalecane)">
        <ol className="list-decimal pl-6 space-y-2">
          <li>
            Zaloguj się do panelu:{' '}
            <a
              href={`${PANEL_URL}/login`}
              className="text-[#0066FF] font-semibold hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {PANEL_URL.replace(/^https?:\/\//, '')}/login
            </a>
          </li>
          <li>
            Przejdź do{' '}
            <a
              href={`${PANEL_URL}/profile?tab=settings`}
              className="text-[#0066FF] font-semibold hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ustawienia konta → Ustawienia
            </a>
            .
          </li>
          <li>W sekcji „Strefa niebezpieczna” wybierz <strong>Usuń konto</strong>.</li>
          <li>Potwierdź hasłem. Operacja jest nieodwracalna.</li>
        </ol>
        <p className="mt-4">
          W aplikacji mobilnej Turnivo te same kroki są opisane w profilu (Pomoc → Usunięcie konta)
          oraz prowadzą do panelu powyżej — usuwanie konta odbywa się w panelu użytkownika.
        </p>
      </LegalSection>

      <LegalSection title="3. Co zostanie usunięte">
        <ul className="list-disc pl-6 space-y-1">
          <li>dane konta (e-mail, imię, nazwisko, telefon, adres, ustawienia),</li>
          <li>dane logowania i sesje (w tym tokeny odświeżające),</li>
          <li>powiązania z turniejami i ligami jako członek / uprawnienia konta,</li>
          <li>powiadomienia i preferencje powiadomień powiązane z kontem,</li>
          <li>historia zamówień / subskrypcji powiązana z kontem (o ile przepisy nie wymagają dłuższego przechowywania dokumentów księgowych).</li>
        </ul>
      </LegalSection>

      <LegalSection title="4. Czego możemy nie usunąć od razu">
        <ul className="list-disc pl-6 space-y-1">
          <li>
            publiczne wyniki turniejów, nazwy drużyn lub wpisy, które opublikowałeś jako organizator —
            mogą pozostać w formie zanonimizowanej lub bez powiązania z Twoim kontem,
          </li>
          <li>
            dane wymagane przepisami prawa (np. rozliczenia podatkowe / faktury) — przez okres
            wynikający z przepisów,
          </li>
          <li>kopie zapasowe techniczne — usuwane zgodnie z cyklem retencji infrastruktury.</li>
        </ul>
        <p className="mt-3">
          Szczegóły: <Link to="/polityka-prywatnosci" className="text-[#0066FF] hover:underline">Polityka prywatności</Link>.
        </p>
      </LegalSection>

      <LegalSection title="5. Czas realizacji">
        <p>
          Usunięcie konta w panelu następuje <strong>natychmiast</strong> po potwierdzeniu hasłem.
          Jeśli nie możesz się zalogować (np. utracone hasło), napisz na{' '}
          <a href="mailto:kontakt@turnivo.pl" className="text-[#0066FF] font-semibold hover:underline">
            kontakt@turnivo.pl
          </a>{' '}
          z adresu e-mail przypisanego do konta. Wniosek rozpatrzymy zwykle w ciągu <strong>14 dni</strong>.
        </p>
      </LegalSection>

      <LegalSection title="6. Dezaktywacja zamiast usunięcia">
        <p>
          W panelu możesz też wybrać <strong>Dezaktywuj konto</strong> — konto zostanie wyłączone
          (brak logowania), ale dane nie są jeszcze trwale kasowane. Pełne usunięcie wymaga kroku
          „Usuń konto”.
        </p>
      </LegalSection>
    </LegalPageShell>
  );
}
